import { boulItems, charItems, patItems, primItems } from "./welcomeItems";

export interface ItemsTechno {
  primary: boolean;
  hasChild: boolean;
  secondary?: boolean;
  disabled: boolean;
  title: string;
  subtitle: string;
  icon: string;
  href?: string;
  size?: "6" | "12";
  backgroundColor: string;
  children?: ItemsTechno[];
}

interface Pole {
  title: string;
  value: number | string;
  href: string;
}

interface Job {
  label: string;
  labelUpper: string;
  key: string;
  href: string;
  itemsWelcome: ItemsTechno[];
  image: string;
  poles: (pole: number) => Pole[] | undefined;
}

const char: Job = {
  label: "charcuterie",
  labelUpper: "Charcuterie",
  key: "char",
  itemsWelcome: charItems,
  href: "char",
  image:
    "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/images-techno/char-logo.png",
  poles: (index) => {
    if (index === 0) {
      return [
        {
          title: "Première année",
          value: 1,
          href: "competences",
        },
        {
          title: "Deuxième année",
          value: 2,
          href: "competences",
        },
      ];
    }
    if (index === 1) {
      return [
        {
          title: "Accès aux vidéos",
          value: 1,
          href: "generiques",
        },
      ];
    }
    if (index === 2) {
      return [
        { title: "Livre 1ère année", value: "annee1", href: "book" },
        { title: "Livre 2ème année", value: "annee2", href: "book" },
      ];
    }
    return undefined;
  },
};

const boul: Job = {
  label: "boulangerie",
  labelUpper: "Boulangerie",
  itemsWelcome: boulItems,
  key: "boul",
  href: "boul",
  image:
    "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/images-techno/boul-logo.png",
  poles: (pole) => {
    if (pole === 0)
      return [
        {
          title: "Accéder aux savoirs associés",
          value: 1,
          href: "competences",
        },
      ];
    if (pole === 1) {
      return [{ title: "Accéder à la pratique", value: 1, href: "generiques" }];
    }
    return undefined;
  },
};

const pat: Job = {
  label: "pâtisserie",
  labelUpper: "Pâtisserie",
  itemsWelcome: patItems,
  key: "pat",
  href: "pat",
  image:
    "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/images-techno/pat-logo.png",
  poles: (pole) => {
    if (pole === 0 || pole === 1) {
      const href = pole === 0 ? "competences" : "generiques";
      return [
        { title: "Pôle 1", value: 1, href },
        { title: "Pôle 2", value: 2, href },
      ];
    }
    return undefined;
  },
};

const prim: Job = {
  label: "primeur",
  labelUpper: "Primeur",
  itemsWelcome: primItems,
  href: "prim",
  key: "prim",
  image:
    "https://deliceo-formace-app-v2.s3.eu-west-3.amazonaws.com/Images/Bannie%CC%80re-De%CC%81lice%CC%81o-primeur(1).png",
  poles: (pole) => {
    if (pole === 0) {
      return [
        { title: "Pôle 1", value: 1, href: "competences" },
        { title: "Pôle 2", value: 2, href: "competences" },
      ];
    }
    if (pole === 1) {
      return [
        { title: "BOUTIQUE", value: 1, href: "generiques" },
        {
          title: "FRAÎCHE DÉCOUPE",
          value: 2,
          href: "generiques",
        },
      ];
    }
    return undefined;
  },
};
export const jobsArray = [char, boul, pat, prim];

export const jobs: Map<string, Job> = new Map(
  jobsArray.map((job) => [job.key, job])
);

export const jobsKeys = jobsArray.map((job) => job.key);
